import { atom } from "jotai";

/**
 * Indicates whether the fast-forward markers are visible to endusers or not.
 * This does not indicate loading them or not. They may still be loaded.
 */
export const ffwdMarkersVisibleAtom = atom<boolean>(false);
